import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/informes/')({
  beforeLoad: () => {
    throw redirect({ to: '/informes/destinatarios' });
  },
});
